import React from 'react';
import {Outlet, useLocation} from "react-router-dom";
import { Helmet } from "react-helmet";
import TalentTeamProvider, { TalentTeamContext } from "../../providers/TalentTeamProvider";
import PageNotAllowed from "../../components/errors/PageNotAllowed";
import {useAuth} from "../../providers/AuthProvider";

const TalentTeamLayout = () => {
    //TODO check auth permissions
    const {auth} = useAuth();
    const { pathname } = useLocation();

    const pageTitle = (teamName) => {
        if (pathname.includes('/team/setup')) {
            return "Setup Team Profile"
        } else if (pathname.includes('/team/manage')) {
            return `Manage Team - ${teamName}`
        }
        return "Teams"
    }

    if (auth.isTalent() && !auth.isProfileApproved()) {
        return <PageNotAllowed redirect="/talent/dashboard" message="Your profile must be approved before accessing this page."/>;
    }
    return (
        <TalentTeamProvider>
            <TalentTeamContext.Consumer>
                {({ team }) => (team?.name ? (
                    <Helmet>
                        <title>{pageTitle(team.name)} | Wripple</title>
                    </Helmet>
                ) : undefined)}
            </TalentTeamContext.Consumer>
            <Outlet />
        </TalentTeamProvider>
    );
};

export default TalentTeamLayout;